"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUpdatePolicyInstruction = exports.updatePolicyInstructionDiscriminator = exports.updatePolicyStruct = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const UpdatePolicyArg_1 = require("../types/UpdatePolicyArg");
/**
 * @category Instructions
 * @category UpdatePolicy
 * @category generated
 */
exports.updatePolicyStruct = new beet.FixableBeetArgsStruct([
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['arg', UpdatePolicyArg_1.updatePolicyArgBeet],
], 'UpdatePolicyInstructionArgs');
exports.updatePolicyInstructionDiscriminator = [
    212, 245, 246, 7, 163, 151, 18, 57,
];
/**
 * Creates a _UpdatePolicy_ instruction.
 *
 * @param accounts that will be accessed while the instruction is processed
 * @param args to provide as instruction data to the program
 *
 * @category Instructions
 * @category UpdatePolicy
 * @category generated
 */
function createUpdatePolicyInstruction(accounts, args, programId = new web3.PublicKey('ocp4vWUzA2z2XMYJ3QhM9vWdyoyoQwAFJhRdVTbvo9E')) {
    const [data] = exports.updatePolicyStruct.serialize({
        instructionDiscriminator: exports.updatePolicyInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: accounts.policy,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.authority,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: accounts.systemProgram ?? web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId,
        keys,
        data,
    });
    return ix;
}
exports.createUpdatePolicyInstruction = createUpdatePolicyInstruction;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXBkYXRlUG9saWN5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2dlbmVyYXRlZC9pbnN0cnVjdGlvbnMvdXBkYXRlUG9saWN5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7R0FLRzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFFSCxnRUFBaUQ7QUFDakQsc0RBQXVDO0FBQ3ZDLDhEQUErRTtBQVUvRTs7OztHQUlHO0FBQ1UsUUFBQSxrQkFBa0IsR0FBRyxJQUFJLElBQUksQ0FBQyxxQkFBcUIsQ0FLOUQ7SUFDRSxDQUFDLDBCQUEwQixFQUFFLElBQUksQ0FBQyxxQkFBcUIsQ0FBQyxJQUFJLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDO0lBQ3BFLENBQUMsS0FBSyxFQUFFLHFDQUFtQixDQUFDO0NBQzdCLEVBQ0QsNkJBQTZCLENBQzlCLENBQUE7QUFnQlksUUFBQSxvQ0FBb0MsR0FBRztJQUNsRCxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxDQUFDLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxFQUFFLEVBQUUsRUFBRTtDQUNuQyxDQUFBO0FBRUQ7Ozs7Ozs7OztHQVNHO0FBQ0gsU0FBZ0IsNkJBQTZCLENBQzNDLFFBQXlDLEVBQ3pDLElBQWlDLEVBQ2pDLFNBQVMsR0FBRyxJQUFJLElBQUksQ0FBQyxTQUFTLENBQUMsNkNBQTZDLENBQUM7SUFFN0UsTUFBTSxDQUFDLElBQUksQ0FBQyxHQUFHLDBCQUFrQixDQUFDLFNBQVMsQ0FBQztRQUMxQyx3QkFBd0IsRUFBRSw0Q0FBb0M7UUFDOUQsR0FBRyxJQUFJO0tBQ1IsQ0FBQyxDQUFBO0lBQ0YsTUFBTSxJQUFJLEdBQXVCO1FBQy9CO1lBQ0UsTUFBTSxFQUFFLFFBQVEsQ0FBQyxNQUFNO1lBQ3ZCLFVBQVUsRUFBRSxJQUFJO1lBQ2hCLFFBQVEsRUFBRSxLQUFLO1NBQ2hCO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUSxDQUFDLFNBQVM7WUFDMUIsVUFBVSxFQUFFLEtBQUs7WUFDakIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVEsQ0FBQyxhQUFhLElBQUksSUFBSSxDQUFDLGFBQWEsQ0FBQyxTQUFTO1lBQzlELFVBQVUsRUFBRSxLQUFLO1lBQ2pCLFFBQVEsRUFBRSxLQUFLO1NBQ2hCO0tBQ0YsQ0FBQTtJQUVELE1BQU0sRUFBRSxHQUFHLElBQUksSUFBSSxDQUFDLHNCQUFzQixDQUFDO1FBQ3pDLFNBQVM7UUFDVCxJQUFJO1FBQ0osSUFBSTtLQUNMLENBQUMsQ0FBQTtJQUNGLE9BQU8sRUFBRSxDQUFBO0FBQ1gsQ0FBQztBQWpDRCxzRUFpQ0MifQ==